<script>
export default {
  name: 'SelectFloatingLabel',

  props: {
    value: {
      default: null,
      type: String,
    },
  },

  mounted() {
    this.hasValue = !!this.value;
  },

  data() {
    return {
      hasValue: false,
    };
  },

  methods: {
    setValue(e) {
      this.hasValue = !!e.target.value;
    },
  },

  render() {
    return this.$scopedSlots.default({
      hasValue: this.hasValue,
      setValue: this.setValue,
    });
  },
}
</script>